import React, { useState, useRef } from 'react';
import Store from '../Store/Store';
import axios from 'axios';

const UploadButton = props => {
  return(
    <>
      <button 
        onClick={ props.onClick } 
        className="button" 
        style={{ margin:12, display:'inline-block' }}
      >
        { props.title }
      </button>
      
      <input 
        type="file" 
        id="files" 
        name="files" 
        style={{ position:'fixed', display:'inline-block', left:'-1024px', top:'-1024px' }}
        ref={ props.imageTagRef }
        onChange={ props.onChange }
        multiple={ true }
      />
      
    </>
  )
}

export default function UploadFile( props ) {

//export default const UploadFile = props => {

  const [ progress, setProgress ] = useState( false )

  const apiRoot = "https://carat80.com/api/"
  const imageTagRef = useRef( null )
  const user = Store.get( 'user' )

  const onChangeHandler = e => {
    let data = new FormData() 

    //console.log( 'e.target.files', e.target.files.FileList )
    Array.from( e.target.files ).forEach( ( file, i ) => { 
      //console.log( 'upload file', file )
      data.append( 'file-' + i, file ) 
    } )
    //data.append( 'file', e.target.files[ 0 ] )

    data.append( 'token', user.token )
    data.append( 'table', props.table || 'rows' )
    data.append( 'ordinal', props.ordinal || '1' )

    axios.post( apiRoot + 'upload', data, { 
      onUploadProgress: progressEvent => { 
        setProgress( progressEvent.loaded / progressEvent.total )
        props.setTmp( props.tmp + 1 )
      }
    })
    .then( result => { 
      //console.log( 'onChangeHandler result.data', result.data )
      setProgress( false )
      props.setTmp( props.tmp + 1 )
      e.target.value = null
      if ( props.onComplete ) {
        props.onComplete( result.data )
      }
    })
  }

  // trigger upload
  const clickUpload = () => {
    imageTagRef.current.click()
  }

  return (
    <>
      { progress  
      ? <>
          <div style={{ padding:'20px 10px', display:'inline-block' }} >
            <div 
              style={{ 
                display:'inline-block', padding:'8px 12px', 
                fontSize:12, fontWeight:600, 
                minWidth:25, border:'1px solid #444', 
                textAlign:'right',   
              }} 
            >
              { Math.round( progress * 100 ) + '%' }
            </div>
          </div>
          <div className="progress-bar" style={{ 
            zIndex:10000, position:'fixed', top:0, left:0, height:'6px', 
            background:'linear-gradient(#42a5f5, #42a5f5aa, #42a5f500)', 
            width:( progress * 100 ) + 'vw', 
          }} />
        </>
      : <UploadButton
          imageTagRef={ imageTagRef }
          title={ "Upload" }
          onChange={ onChangeHandler }
          onClick={ clickUpload } 
        />
      }  
    </>
  )
}

//export default UploadFile
